(() => {
  if (customElements.get('njt-vehicle-strip')) return;
  class VehicleStrip extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.sync = () => this.update();
      window.addEventListener('popstate', this.sync);
      document.addEventListener('njt:vehicle-state', this.sync);
      this.querySelector('[data-vehicle-open]').setAttribute('aria-expanded', 'false');
      this.querySelector('[data-vehicle-open]').addEventListener('click', () => this.openPicker());
      this.querySelector('[data-vehicle-clear]').addEventListener('click', () => {
        if(window.globalVehicleFilter?.clearFilter) window.globalVehicleFilter.clearFilter();
      });
      this.update();
    }
    disconnectedCallback() {
      window.removeEventListener('popstate', this.sync);
      document.removeEventListener('njt:vehicle-state', this.sync);
      this.pickerObserver?.disconnect();
      this.picker?.querySelector('.close-button')?.removeEventListener('click', this.closeHandler, true);
      this.picker?.querySelectorAll('[data-njv-label],.njv-help').forEach(el => el.remove());
      this.animation?.cancel();
      if (this.picker && this.pickerHome?.isConnected) {
        this.picker.classList.add('closed');
        this.pickerHome.after(this.picker);
      }
      this.panel?.remove();
      this.pickerHome?.remove();
    }
    openPicker() {
      const picker = document.querySelector('.section-vehicle-filter--wrapper');
      if (!picker) return;
      if (!this.panel) {
        this.picker = picker;
        this.pickerHome = document.createComment('vehicle-picker-home');
        picker.before(this.pickerHome);
        this.panel = document.createElement('div');
        this.panel.className = 'njv-inline-panel';
        this.after(this.panel);
        this.panel.append(picker);
        const title = picker.querySelector('.headline > span');
        if (title) title.textContent = this.dataset.findTitle;
        const names = [this.dataset.makeLabel, this.dataset.modelLabel, this.dataset.vehicleLabel];
        picker.querySelectorAll('.select-your-vehicle-box select').forEach((select, i) => {
          const label = document.createElement('label');
          label.dataset.njvLabel = '';
          label.htmlFor = select.id;
          label.textContent = names[i];
          select.parentElement.prepend(label);
        });
        const confirm = picker.querySelector('.button__confirm > span');
        if (confirm) confirm.textContent = this.dataset.showParts;
        const close = picker.querySelector('.close-button');
        close.type = 'button';
        close.setAttribute('aria-label', this.dataset.closeLabel);
        close.textContent = '×';
        this.closeHandler = e => { e.stopImmediatePropagation(); this.closePicker(); };
        close.addEventListener('click', this.closeHandler, true);
        this.panel.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); this.closePicker(); } });
        this.pickerObserver = new MutationObserver(() => {
          this.querySelector('[data-vehicle-open]').setAttribute('aria-expanded', String(!picker.classList.contains('closed')));
        });
        this.pickerObserver.observe(picker, {attributes:true, attributeFilter:['class']});
      }
      if (!picker.classList.contains('closed')) { this.closePicker(); return; }
      this.animation?.cancel();
      picker.classList.remove('closed');
      this.querySelector('[data-vehicle-open]').setAttribute('aria-expanded', 'true');
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches && this.panel.animate) {
        this.animation = this.panel.animate([{height:'0px', opacity:0}, {height:this.panel.scrollHeight+'px', opacity:1}], {duration:240, easing:'ease-out'});
      }
      picker.querySelector('select')?.focus({preventScroll:true});
    }
    closePicker() {
      if (!this.picker || this.picker.classList.contains('closed')) return;
      this.animation?.cancel();
      const finish = () => {
        this.picker.classList.add('closed');
        this.querySelector('[data-vehicle-open]').setAttribute('aria-expanded', 'false');
        this.querySelector('[data-vehicle-open]').focus({preventScroll:true});
      };
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches && this.panel.animate) {
        this.animation = this.panel.animate([{height:this.panel.scrollHeight+'px', opacity:1}, {height:'0px', opacity:0}], {duration:180, easing:'ease-in'});
        this.animation.onfinish = finish;
      } else finish();
    }
    update() {
      const selected = new URL(location.href).searchParams.get('filter.p.m.organizer.car_models') || '';
      const button = this.querySelector('[data-vehicle-open]'), message = this.querySelector('p');
      this.querySelector('[data-vehicle-clear]').hidden=!selected;
      this.querySelector('.njt-vehicle-icon').hidden=!selected;
      const photoOption = [...document.querySelectorAll('#vehicle-identifiers option')].find(o => o.value === selected);
      const photo = this.querySelector('[data-vehicle-image]');
      const photoUrl = photoOption?.dataset.vehicleImage || '';
      if (photo) {
        photo.hidden = !selected || !photoUrl;
        if (photoUrl && selected) {
          if (photo.getAttribute('src') !== photoUrl) photo.src = photoUrl;
        } else photo.removeAttribute('src');
      }
      const pickup=/f[ -]?(?:150|250|350|450)|ram|silverado|sierra|tacoma|tundra|titan|frontier|ranger|colorado|canyon|avalanche|ridgeline|maverick/i.test(selected);
      this.querySelector('[data-vehicle-pickup]').hidden=!pickup || Boolean(photoUrl);
      this.querySelector('[data-vehicle-jeep]').hidden=pickup || Boolean(photoUrl);
      button.textContent = selected ? this.dataset.change : '+ ' + this.dataset.add;
      message.replaceChildren();
      if (selected) {
        this.setAttribute('data-selected-vehicle', selected);
        const option = [...document.querySelectorAll('#vehicle-identifiers option')].find(o => o.value === selected);
        const vehicle = document.createElement('strong');
        const title = option?.textContent.trim() || selected;
        const years = title.match(/\b\d{4}\s*[-–]\s*(?:\d{4}|present)\b/i);
        if (years) {
          vehicle.append(document.createTextNode(title.slice(0, years.index)));
          const range = document.createElement('span');
          range.className = 'njt-vehicle-years';
          range.textContent = years[0];
          vehicle.append(range, document.createTextNode(title.slice(years.index + years[0].length)));
        } else vehicle.textContent = title;
        const desktopLabel = document.createElement('span');
        desktopLabel.className = 'njt-vehicle-label-desktop';
        desktopLabel.textContent = this.dataset.selected;
        const mobileLabel = document.createElement('span');
        mobileLabel.className = 'njt-vehicle-label-mobile';
        mobileLabel.textContent = this.dataset.selectedMobile || this.dataset.selected;
        message.append(desktopLabel, mobileLabel, vehicle);
      } else {
        this.removeAttribute('data-selected-vehicle');
        message.textContent = this.dataset.prompt;
      }
    }
  }
  customElements.define('njt-vehicle-strip', VehicleStrip);
})();
